import {Injectable} from '@angular/core';
import {G2Product} from '../../../models/g2-review.model';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {TranslationService} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class WriteReviewDialogService {

  public translationSubscriptionHeadline: Subscription = Subscription.EMPTY;

  constructor(
    private launchDialogService: LaunchDialogService,
    protected translation: TranslationService
  ) {
  }

  openDialog(link: string, headlineText: string) {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.WRITE_REVIEW, null, {
      link,
      headlineText
    });
  }

  openReadReviewDialog(link: string) {
    this.prepareDialogTexts(link, 'productReview.readAReview');
  }

  openWriteAReviewDialog(g2Product: G2Product) {
    this.prepareDialogTexts(g2Product.write_review_url, 'productReview.writeAReviewUppercase');
  }

  prepareDialogTexts(link: string, headlineTranslationKey: string) {
    this.translationSubscriptionHeadline.unsubscribe();
    this.translationSubscriptionHeadline = this.translation.translate(headlineTranslationKey)
      .pipe(take(1), untilDestroyed(this))
      .subscribe(headlineText => {
        this.openDialog(link, headlineText);
      });
  }
}
